import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import CallbackWidget from "./CallbackWidget";
import OfficeHoursBanner from "./OfficeHoursBanner";
import OfferPopup from "./OfferPopup";
import { Toaster } from "sonner";
import { I18nProvider } from "../../i18n/I18nProvider";
import { ContentProvider } from "../../lib/ContentProvider";
import { LocalBusinessJsonLd } from "../seo/JsonLd";
import Hreflang from "../seo/Hreflang";
import { useLocation } from "react-router-dom";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <I18nProvider>
      <ContentProvider>
      <div className="App min-h-screen flex flex-col bg-white">
        <Hreflang />
        <LocalBusinessJsonLd />
        {!isAdmin && <Header />}
        {!isAdmin && <OfficeHoursBanner />}
        <main className={`flex-1 ${!isAdmin ? "pt-16 md:pt-20" : ""}`}>{children}</main>
        {!isAdmin && <Footer />}
        {!isAdmin && <CallbackWidget />}
        <OfferPopup />
        <Toaster position="bottom-right" richColors />
      </div>
      </ContentProvider>
    </I18nProvider>
  );
}
